import styles from "./styles.module.css";
import * as Editors from "../../../editors";
import { useState, useEffect } from "react";
export default function PropInput({ prop, style, index, onChange }) {
  const Input = Editors[prop.editor];

  const _onChange = (v) => {
    const _style = { ...style };
    _style.props[prop.name] = v;
    onChange(_style);
  };

  if (!Input) {
    return null;
  }
  return (
    <div style={{ zIndex: 300 - index }} className={styles.propInput}>
      <div className={styles.propTitle}>{prop.displayName}</div>
      <Input
        value={style.props[prop.name]}
        params={prop.editorParams}
        onChange={_onChange}
      />
      <div className={styles.propHelp}>{prop.help}</div>
    </div>
  );
}
